import {Loader} from "../../_snowpack/pkg/@googlemaps/js-api-loader.js";
class DistrictMap {
  constructor(container) {
    this.container = container;
    this.districts = [];
    this.activeMarker = null;
    this.yellowBinIconPath = "/_assets/b4827e95e0ae2a903de014154bde0680/Icons/muelltrennung-wirkt_trennen-xxl_tonne.svg";
    this.pinIconPath = "/_assets/b4827e95e0ae2a903de014154bde0680/Icons/muelltrennung-wirkt_trennen-xxl_pin.svg";
    const apiKey = container.getAttribute("data-key");
    const districtsData = container.getAttribute("data-districts");
    try {
      this.districts = JSON.parse(districtsData);
    } catch (error) {
      console.error("Error parsing district data: ", error);
    }
    const loader = new Loader({apiKey, libraries: ["places"]});
    loader.load().then(() => this.initializeMap());
  }
  initializeMap() {
    const mapElement = this.container.querySelector(".district-map");
    this.map = new google.maps.Map(mapElement, {
      center: {lat: 51.1657, lng: 10.4515},
      zoom: 6,
      disableDefaultUI: true
    });
    this.placeMarkers().then(() => {
      mapElement.style.height = "100%";
      this.setupSearch();
    });
  }
  async placeMarkers() {
    return new Promise((resolve) => {
      this.districts.forEach((district, index, array) => {
        const marker = new google.maps.Marker({
          position: {lat: district.latitude, lng: district.longitude},
          map: this.map,
          title: district.name,
          icon: this.yellowBinIconPath
        });
        marker.addListener("click", () => {
          if (this.activeMarker) {
            this.activeMarker.setIcon(this.yellowBinIconPath);
          }
          marker.setIcon(this.pinIconPath);
          this.activeMarker = marker;
          this.displayInfoWindow(district);
        });
        if (index === array.length - 1) {
          resolve();
        }
      });
    });
  }
  displayInfoWindow(district) {
    const infoWindow = this.container.querySelector(".district-map__custom-info-window");
    infoWindow.classList.remove("hidden");
    infoWindow.classList.add("visible");
    const contentContainer = infoWindow.querySelector(".district-map__window-content");
    contentContainer.innerHTML = "";
    contentContainer.appendChild(this.createContent(district));
    const closeButton = infoWindow.querySelector(".district-map__close");
    closeButton.addEventListener("click", () => {
      if (this.activeMarker) {
        this.activeMarker.setIcon(this.yellowBinIconPath);
      }
      infoWindow.classList.remove("visible");
      infoWindow.classList.add("hidden");
    });
  }
  createContent(district) {
    const content = document.createElement("div");
    const disrtictSection = document.createElement("div");
    disrtictSection.classList.add("district-map__window-section");
    const heading = document.createElement("h3");
    heading.classList.add("headline");
    heading.textContent = district.name;
    disrtictSection.appendChild(heading);
    const description = document.createElement("p");
    description.classList.add("margin-top--xs", "margin-bottom--xs");
    description.textContent = district.description;
    disrtictSection.appendChild(description);
    if (district.link) {
      const link = document.createElement("a");
      link.classList.add("text-with-icon", "margin-bottom--xs");
      link.href = district.link;
      link.textContent = "Zur Aktionsseite";
      link.target = "_blank";
      disrtictSection.appendChild(link);
    }
    content.appendChild(disrtictSection);
    if (district.packagingLocations.length) {
      const locationsSection = document.createElement("div");
      locationsSection.classList.add("district-map__window-section");
      const locationsHeading = document.createElement("strong");
      locationsHeading.classList.add("margin-bottom--xs");
      locationsHeading.textContent = `Verpackungsstandort${district.packagingLocations.length > 1 ? "e" : ""}`;
      locationsSection.appendChild(locationsHeading);
      const locationsList = document.createElement("ul");
      locationsList.classList.add("margin-bottom--xs");
      district.packagingLocations.forEach((loc) => {
        const listItem = document.createElement("li");
        listItem.textContent = loc.description;
        locationsList.appendChild(listItem);
      });
      locationsSection.appendChild(locationsList);
      content.appendChild(locationsSection);
    }
    if (district.packagingEvents.length) {
      const locationsSection = document.createElement("div");
      locationsSection.classList.add("district-map__window-section");
      const eventsHeading = document.createElement("strong");
      eventsHeading.textContent = "Events";
      locationsSection.appendChild(eventsHeading);
      const eventsList = document.createElement("ul");
      eventsList.classList.add("margin-bottom--xs");
      district.packagingEvents.forEach((event) => {
        const eventItem = document.createElement("li");
        eventItem.textContent = event.description;
        eventsList.appendChild(eventItem);
      });
      locationsSection.appendChild(eventsList);
      content.appendChild(locationsSection);
    }
    return content;
  }
  setupSearch() {
    const searchContainer = this.container.querySelector(".district-map__search");
    const searchInput = searchContainer.querySelector(".district-map__search-input");
    const searchIcon = searchContainer.querySelector(".district-map__search-icon");
    const autocomplete = new google.maps.places.Autocomplete(searchInput, {
      componentRestrictions: {country: "de"}
    });
    autocomplete.bindTo("bounds", this.map);
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      this.centerMapOnPlace(place);
    });
    searchIcon.addEventListener("click", () => {
      this.manualSearch(autocomplete, searchInput);
    });
    searchInput.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        this.manualSearch(autocomplete, searchInput);
      }
    });
    searchContainer.classList.remove("hidden");
  }
  centerMapOnPlace(place) {
    if (!place.geometry || !place.geometry.location) {
      console.error("Place has no geometry");
      return;
    }
    if (place.geometry.viewport) {
      this.map.fitBounds(place.geometry.viewport);
    } else {
      this.map.setCenter(place.geometry.location);
      this.map.setZoom(15);
    }
  }
  manualSearch(autocomplete, searchInput) {
    const place = autocomplete.getPlace();
    if (place && place.geometry) {
      this.centerMapOnPlace(place);
    } else {
      const service = new google.maps.places.PlacesService(this.map);
      service.findPlaceFromQuery({
        query: searchInput.value,
        fields: ["geometry"],
        locationBias: this.map.getBounds()
      }, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && results[0]) {
          this.centerMapOnPlace(results[0]);
        } else {
          console.error("No places results found.");
        }
      });
    }
  }
}
const districtMapContainer = document.querySelector(".district-map__container");
if (districtMapContainer) {
  new DistrictMap(districtMapContainer);
} else {
  console.error("District map container not found");
}
